module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** external "true"
 ** module id = 264
 ** module chunks = 0
 **/